import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { MarketEachWayState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/marketEachWay/MarketEachWay.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export interface MarketEachWayPropsType {
    marketId: MarketId;
}

export const MarketEachWay = observer('MarketEachWay', (propsIn: MarketEachWayPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [state] = useState(() => new MarketEachWayState(appState, props));
    const marketModel = props.marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    return (<div>
        <h4>Each Way</h4>

        <div className='row'>
            <div className='col-6'>
                <div className='element checkbox' data-test='each-way-checkbox'>
                    <label>
                        <input type='checkbox' defaultChecked={ state.eachWayOffered.value ?? false } onChange={state.onChangeEachWayOffered}/>
                        <span>
                            Each way
                        </span>
                    </label>
                </div>

                <div className={`element hasLabel ${state.eachWayPlaces.getError !== null ? 'invalid error' : ''}`} data-test='each-way-terms-places-input'>
                    <input
                        type='text'
                        name='eachWay.terms.places'
                        value={state.eachWayPlaces.value?.toString() ?? ''}
                        onChange={state.onChangeTermsPlaces}
                        disabled={!(state.eachWayOffered.value ?? false)}
                    />
                    <label>Places</label>
                    {
                        state.eachWayPlaces.getError !== null ?
                            <div className='error-message'>
                                <div className='error-message-content'>{state.eachWayPlaces.getError}</div>
                            </div> : null
                    }
                </div>
            </div>
            <div className='col-6'>
                <div className='element checkbox' data-test='each-way-terms-with-bet-checkbox'>
                    <label>
                        <input type='checkbox' defaultChecked={ state.eachWayTermsWithBet.value ?? false} onChange={state.onChangeEachWayTermsWithBet} />
                        <span>
                            Terms with bet
                        </span>
                    </label>
                </div>

                <div className={`element hasLabel ${state.eachWaytermsReduction.getError !== null ? 'invalid error' : ''}`} data-test='each-way-terms-place-reduction-input'>
                    <input
                        type='text'
                        name='eachWay.terms.reduction'
                        value={state.eachWaytermsReduction.value?.toString() ?? ''}
                        onChange={state.onChangeTermsReduction}
                        disabled={!(state.eachWayOffered.value ?? false)}
                    />
                    <label>Place reduction</label>
                    {
                        state.eachWaytermsReduction.getError !== null ?
                            <div className='error-message'>
                                <div className='error-message-content'>{state.eachWaytermsReduction.getError}</div>
                            </div> : null
                    }
                </div>
            </div>
        </div>

        <div className='buttons'>
            <button className={`btn ${state.isActiveSaveButton ? '' : 'disabled'}`} onClick={state.saveEachWay} data-test='save-each-way-settings-button'>
                Save each way settings
            </button>
        </div>
    </div>);
});
